import { ref } from 'vue'
import { stripeControllerCreatePortal as createPortal } from '@/gen/clients/stripeControllerCreatePortal'
import { useToastService } from '@/composables/toastService'

export function useStripePortal() {
  const isLoading = ref(false)
  const { showToast } = useToastService()

  async function redirectToPortal() {
    isLoading.value = true
    try {
      const response = await createPortal({ returnUrl: window.location.href })
      const url =
        (typeof response.url === 'string' ? response.url : undefined) ??
        Object.values(response).find((value): value is string => typeof value === 'string')
      if (!url) {
        showToast('Billing portal unavailable right now. Please try again.')
        return
      }
      window.location.href = url
    } catch {
      showToast('Failed to open billing portal. Please try again.')
    } finally {
      isLoading.value = false
    }
  }

  return { redirectToPortal, isLoading }
}
